import { Loader2 } from "lucide-react";

const VARIANTS = {
    primary:
        "bg-ux-accent text-[#0B0F14] hover:brightness-110 disabled:bg-ux-bg-3 disabled:text-ux-text-3",
    secondary:
        "bg-transparent border border-ux-border-2 text-ux-text-1 hover:bg-ux-bg-2 disabled:text-ux-text-3",
    danger:
        "bg-transparent border border-ux-danger text-ux-danger hover:bg-ux-danger-soft disabled:opacity-50",
    warning:
        "bg-transparent border border-ux-warning text-ux-warning hover:bg-ux-warning-soft disabled:opacity-50",
    ghost:
        "bg-transparent text-ux-text-2 hover:text-ux-text-1 hover:bg-ux-bg-2 disabled:opacity-50",
};

export default function SpinnerButton({
    loading = false,
    disabled = false,
    onClick,
    type = "button",
    variant = "primary",
    className = "",
    children,
    testId,
    title,
    "aria-label": ariaLabel,
}) {
    const base =
        "inline-flex items-center justify-center gap-1.5 text-[13px] font-medium px-3 h-9 rounded-md transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-ux-accent disabled:cursor-not-allowed";
    return (
        <button
            type={type}
            disabled={disabled || loading}
            onClick={onClick}
            data-testid={testId}
            title={title}
            aria-label={ariaLabel}
            className={[base, VARIANTS[variant], className].join(" ")}
        >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {children}
        </button>
    );
}
